const modalOpenClass = 'product_swiper_modal_open';
let projectSwiper = null;

window.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName(modalOpenClass);
  if (!elements) return;

  Array.from(elements).forEach((element) => {
    element.addEventListener('click', (event) => {
      event.preventDefault();

      if (projectSwiper) {
        projectSwiper.destroy(true, true);
        projectSwiper = null;
      }

      const slideLength = document.querySelectorAll('#swiper_wrap .swiper-slide').length
      let options = {};
      if (slideLength === 1) {
        options = {
          containerModifierClass: 'swiper_passive',
          allowTouchMove: false,
          loop: false,
          speed: 400,
          navigation: {
            nextEl: ".modal-swiper-button-next",
            prevEl: ".modal-swiper-button-prev",
          }
        }
      } else {
        options = {
          allowTouchMove: false,
          loop: true,
          speed: 400,
          navigation: {
            nextEl: ".modal-swiper-button-next",
            prevEl: ".modal-swiper-button-prev"
          }
        }
      }

      projectSwiper = new Swiper('.modal_swiper', options);

      const index = parseInt(element.id, 10);
      if (options.loop) {
        projectSwiper.slideToLoop(index, 0);
      } else {
        projectSwiper.slideTo(index, 0);
      }

      $('#modal').addClass('open');
      $('body').addClass('hidden');
    });
  });

  $('#modal_close, #modal_background').on('click', function () {
    $('#modal').removeClass('open');
    $('body').removeClass('hidden');
    if (projectSwiper) {
      projectSwiper.destroy(true, true);
      projectSwiper = null;
    }
  });
});
